module.exports = __webpack_public_path__ + "img/eg-2.ae194a77.png";